import axios from "axios";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { url } from "../link";
const Updateexpense = () => {
  var rx = 0;
  const { state } = useLocation();
  const [id, setid] = useState(state[rx++]);
  const [expense, setexpense] = useState(state[rx++]);
  const [amount, setamount] = useState(state[rx++]);
  const [curdate, setcurdate] = useState(state[rx++]);
  const nav = useNavigate();
  const submitdata = () => {
    const value = {
      id: id,
      expense: expense,
      amount: amount,
      curdate: curdate,
    };
    axios.post(url + "/edusphere/updateexpense", value).then((response) => {
      nav("/viewexpense");
    });
  };
  return (
    <div>
      <h1>Add expense</h1>
      <div className="form-floating mb-3 mt-3">
        <input
          type="text"
          className="form-control"
          onChange={(e) => setid(e.target.value)}
          value={id}
          placeholder="Enter id"
        />
        <label htmlFor="id">id</label>
      </div>

      <div className="form-floating mb-3 mt-3">
        <input
          type="text"
          className="form-control"
          onChange={(e) => setexpense(e.target.value)}
          value={expense}
          placeholder="Enter expense"
        />
        <label htmlFor="expense">expense</label>
      </div>

      <div className="form-floating mb-3 mt-3">
        <input
          type="text"
          className="form-control"
          onChange={(e) => setamount(e.target.value)}
          value={amount}
          placeholder="Enter amount"
        />
        <label htmlFor="amount">amount</label>
      </div>

      <div className="form-floating mb-3 mt-3">
        <input
          type="text"
          className="form-control"
          onChange={(e) => setcurdate(e.target.value)}
          value={curdate}
          placeholder="Enter curdate"
        />
        <label htmlFor="curdate">curdate</label>
      </div>

      <input
        type="submit"
        className="btn btn-primary"
        onClick={submitdata}
        style={{ width: "100%" }}
      />
    </div>
  );
};
export default Updateexpense;
